module.exports = __webpack_public_path__ + "img/queue_card_medium.7ffe6de8.svg";